import Product from './Product';
import Questionnaire from './Questionnaire';
import CONST from '../CONST';

const Oracle = ({ utilities }) => {
    const { program, state } = utilities;
    const { id: currentPageId } = state.history[0];
    const { products } = program.matches.find(
        ({ matcher }) => matcher(state)
    ) || { products: undefined };

    return currentPageId === CONST.PAGE_PRODUCTS && products ? (
        <ul className={ 'oracle ' + (products.length > 1 ? 'dual' : '') }>
            { products.map((product, index) => (
                <li key={ index }>
                    { index === 0 && <h1>Based on your responses we recommend:</h1> }
                    { index === 1 && <h1>Also great:</h1> }
                    <Product id={ product } />
                </li>
            ))}
        </ul>
    ) : (
        <Questionnaire
            utilities={ utilities }
        />
    );
};

export default Oracle;
